// Centralized external destinations.
// JotForm intake generates the hidden patient ID + backup lead list,
// then forwards the user to the Healthie EHR intake.
export const INTAKE_URL =
  "https://integratedwellness.jotform.com/261624944672060";

// JotForm AI Agent ID — embed appears site-wide as a floating chatbot.
export const JOTFORM_AGENT_ID = "019f1d0a2b907cccb7cf26a760329dad4523";
